import { css } from '@emotion/react'
import {
  Heading,
  Link,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'

import { getMarketplaceTermsLink } from '@/utils/products'
import InfoAlert from '../InfoAlert'

const alertCss = css`
  margin-bottom: var(${SpacingToken.Spacing7});

  [class*='__alert__content__wrapper__text'] {
    max-width: 100%;
  }
`

const titleCss = css`
  && {
    margin-bottom: var(${SpacingToken.Spacing2});
  }
`

const termsLink = getMarketplaceTermsLink()

const marketplaceTerms = (
  <Link href={termsLink} target="_blank" rel="noopener">
    Marketplace Terms
  </Link>
)

const getTermsCopy = (hasScopes: boolean, privacyPolicyUrl?: string) => {
  const privacyPolicy = (
    <Link href={privacyPolicyUrl} target="_blank" rel="noopener">
      App Privacy Policy
    </Link>
  )

  if (!privacyPolicyUrl && !hasScopes) {
    return <>By installing this app, you agree to the {marketplaceTerms}.</>
  }

  if (!privacyPolicyUrl && hasScopes) {
    return (
      <>
        By installing this app, you agree to the {marketplaceTerms} and Scopes
        listed in this section.
      </>
    )
  }

  if (privacyPolicyUrl && !hasScopes) {
    return (
      <>
        By installing this app, you agree to the {marketplaceTerms} and{' '}
        {privacyPolicy}.
      </>
    )
  }

  return (
    <>
      By installing this app, you agree to the {marketplaceTerms},{' '}
      {privacyPolicy} and Scopes listed in this section.
    </>
  )
}

interface Props {
  privacyPolicyUrl?: string
  hasScopes: boolean
}

export const TermsBanner = ({ privacyPolicyUrl, hasScopes }: Props) => {
  const copy = getTermsCopy(hasScopes, privacyPolicyUrl)

  return (
    <InfoAlert data-test="legal-terms-section" css={alertCss}>
      <Heading size="xs" css={titleCss}>
        Legal Terms
      </Heading>
      <Text>{copy}</Text>
    </InfoAlert>
  )
}
